import React from "react"
import Section from "./Section/Section"
import SpeechBabble from "./SpeechBabble/SpeechBabble"
import pxp_feedback_kiosk_stand from "../../../images/decorative/pxp-feedback-kiosk-stand.webp"
import { XpressOn } from "../XpressOn"

type TerminalSmiliesProps = {
  token: string
  children: React.ReactElement
}

const TerminalSmilies = ({ token, children }: TerminalSmiliesProps) => {
  return (
    <Section direction="row" style={{ padding: 0 }}>
      <div style={{ minWidth: "240px", marginRight: "10px" }}>
        <SpeechBabble>{children}</SpeechBabble>
        <XpressOn token={token} />
      </div>
      <div>
        <img
          src={pxp_feedback_kiosk_stand}
          alt="pxp feedback kiosk stand"
          style={{ maxHeight: "40rem" }}
        />
      </div>
    </Section>
  )
}

export default TerminalSmilies
